<template>
  <!-- Content Wrapper -->
  <div>
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">{{ pageTitle }}</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">橫額</li>
              <li class="breadcrumb-item">
                <router-link to="/admin/Banner"> 橫額設定 </router-link>
              </li>
              <li class="breadcrumb-item active">{{ pageTitle }}</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-6 col-sm-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <el-form
                      :model="ruleForm"
                      :rules="rules"
                      ref="Form"
                      label-width="100px"
                      class="demo-ruleForm"
                      :label-position="labelPosition"
                      v-loading="loading"
                    >
                      <el-form-item label="廣告圖片" prop="sgL_UploadTemplId">
                        <el-image
                          style="width: 100%; height: 100px"
                          :src="ruleForm.sgL_ImageUrl"
                        >
                          <div slot="error" class="image-slot">
                            <div class="noImg"></div>
                          </div>
                        </el-image>
                      </el-form-item>
                      <el-form-item label="">
                        <el-upload
                          class="upload-demo"
                          :action="uploadImageUrl"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="errorUpload"
                          :before-upload="beforeUpload"
                        >
                          <el-button size="small" type="primary"
                            >上載廣告圖片</el-button
                          >
                        </el-upload>
                      </el-form-item>
                      <el-form-item label="廣告名稱" prop="sgL_ImageTitle">
                        <el-input
                          placeholder="e.g. 渣打香港馬拉松2021"
                          v-model="ruleForm.sgL_ImageTitle"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="廣告連結" prop="sgL_ImageClickUrl">
                        <el-input
                          placeholder="e.g. https://www.soonnet.org"
                          v-model="ruleForm.sgL_ImageClickUrl"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="廣告描述/備註" prop="sgL_Remark">
                        <el-input
                          placeholder="e.g. 網上報名現已開放"
                          v-model="ruleForm.sgL_Remark"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="廣告商">
                        <el-select
                          v-model="ruleForm.sgL_BrandId"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in BrandList"
                            :key="item.id"
                            :label="item.sgL_Name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="刊登位置" prop="sgL_Type">
                        <el-select
                          v-model="ruleForm.sgL_Type"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in BannerTypeList"
                            :key="item.key"
                            :label="item.vl"
                            :value="item.key"
                          >
                          </el-option>
                        </el-select>
                        <a :href="demoUrl" target="_blank">查看刊登位置</a>
                      </el-form-item>
                      <el-form-item label="開始日期" prop="sgL_StartTime">
                        <el-date-picker
                          v-model="ruleForm.sgL_StartTime"
                          type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="結束日期" prop="sgL_EndTime">
                        <el-date-picker
                          v-model="ruleForm.sgL_EndTime"
                          type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="狀態" prop="sgL_Status">
                        <el-select v-model="sgL_Status" placeholder="请选择">
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <router-link to="/admin/Banner">
                          <el-button type="info">取消</el-button>
                        </router-link>
                        <el-button type="success" @click="save('Form')"
                          >保存</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sortable from "../../../node_modules/sortablejs";
import base from "../../api/httpApi/base";
import { Message } from "element-ui";
export default {
  data() {
    return {
      loading: true,
      pageTitle: "新增橫額",
      uploadImageUrl: "",
      isAdd: true,
      demoUrl: `${base.evi}/advertise`,
      options: [
        {
          value: "NotStarted",
          label: "未開始",
        },
        {
          value: "InPublication",
          label: "刊登中",
        },
        {
          value: "Expired",
          label: "已过期",
        },
        {
          value: "NotShow",
          label: "不顯示",
        },
      ],
      sgL_Status: "",
      labelPosition: "right",
      ruleForm: {
        sgL_ImageTitle: "",
        sgL_UploadTemplId: 0,
        sgL_ImageClickUrl: "",
        sgL_ImageUrl: "",
        id: 0,
        sgL_BrandId: "",
        sgL_Type: "",
        sgL_StartTime: "",
        sgL_EndTime: "",
      },
      BrandList: [],
      BannerTypeList: [],
      rules: {
        sgL_UploadTemplId: [
          { required: true, message: "請上传橫額圖片", trigger: "blur" },
        ],
        sgL_ImageTitle: [
          { required: true, message: "請輸入橫額名稱", trigger: "blur" },
        ],
        sgL_ImageClickUrl: [
          { required: true, message: "請輸入橫額連結", trigger: "blur" },
        ],
        sgL_Type: [
          { required: true, message: "請選擇刊登位置", trigger: "blur" },
        ],
        sgL_StartTime: [
          { required: true, message: "請選開始日期", trigger: "blur" },
        ],
        sgL_EndTime: [
          { required: true, message: "請選結束日期", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    //从store中读取user数据
    this.user = this.$store.getters.getUser;
    this.uploadImageUrl = `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=IndexBanner&id=${this.user.userId}`;
    var query = this.$route.query;
    if (query != null && query.Id != null) {
      if (query.Id > 0) {
        this.isAdd = false;
        this.pageTitle = "編輯橫額";
        this.get(query.Id);
      }
    } else {
      this.loading = false;
    }
    this.getBrandGetAll();
    this.getBannerTypeList();
  },
  mounted() {},
  methods: {
    async getBannerTypeList() {
      this.$api.ad.getBannerTypeList(null).then((res) => {
        Object.keys(res.data.result).forEach((key) => {
          this.BannerTypeList.push({
            key,
            vl: `(${key + ")" + res.data.result[key]}`,
          });
        });
      });
    },
    async getBrandGetAll() {
      this.$api.ad
        .AdminBrandGetAll(null)
        .then((res) => {
          if (res.data.success) {
            this.BrandList = res.data.result.items;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
        });
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.sgL_UploadTemplId == 0) {
            Message({
              type: "warning",
              message: "請上傳圖片",
            });
            return;
          }
          let params = {
            sgL_UploadTemplId: this.ruleForm.sgL_UploadTemplId,
            sgL_ImageClickUrl: this.ruleForm.sgL_ImageClickUrl,
            sgL_ImageTitle: this.ruleForm.sgL_ImageTitle,
            sgL_Remark: this.ruleForm.sgL_Remark,
            sgL_BrandId: this.ruleForm.sgL_BrandId,
            sgL_Type: this.ruleForm.sgL_Type,
            sgL_StartTime: this.ruleForm.sgL_StartTime,
            sgL_EndTime: this.ruleForm.sgL_EndTime,
            sgL_Status: this.sgL_Status,
            sgL_IsDel: false,
            id: this.ruleForm.id,
          };
          let mh = null;
          if (this.isAdd) {
            mh = this.$api.permissionApi.createBannerInfo(params);
          } else {
            mh = this.$api.permissionApi.updateBannerInfo(params);
          }
          mh.then((res) => {
            if (res.data.success) {
              Message({
                type: "success",
                message: this.$t('message.operatesuccessfully'),
              });
              this.$router.push("/admin/Banner");
            } else {
              Message({
                type: "error",
                message: res.data.error.message,
              });
            }
          }).catch((err) => {
            Message({
              type: "error",
              message: err,
            });
            this.loading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    get(id) {
      this.loading = true;
      let params = {
        id: id,
      };
      this.$api.permissionApi
        .getBannerInfo(params)
        .then((res) => {
          if (res.data.success) {
            this.ruleForm = res.data.result;
            if (this.ruleForm.sgL_BrandId == 0) {
              this.ruleForm.sgL_BrandId = "";
            }
            this.sgL_Status = this.ruleForm.sgL_Status;
          } else {
            Message({
              type: "error",
              message: result.data.error.message,
            });
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
          this.loading = false;
        })
        .then((obj) => {
          this.loading = false;
        });
    },
    //#region 上传图片
    handleSuccess(res, file) {
      this.ruleForm.sgL_UploadTemplId = res.result.uploadId;
      this.ruleForm.sgL_ImageUrl = res.result.url;
    },
    beforeUpload(file) {
      console.log("fileType", file.type);
      const isJPG = file.type === "image/jpeg";
      const ispng = file.type === "image/png";
      const isGif = file.type === "image/gif";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !ispng && !isGif) {
        this.$message.error("圖片只能是 JPG/png/gif 格式!");
      }
      if (!isLt5M) {
        this.$message.error("圖片大小不能超过 5MB!");
      }
      return (isJPG || ispng || isGif) && isLt5M;
    },
    errorUpload(err, file, fileList) {
      this.$message.error("上傳失敗" + err);
    },
  },
};
</script>
<style scoped>
.noImg {
  width: 100%;
  height: 100px;
  background-color: darkgray;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminBanner/CreateBanner.vue